import "./PrincipalNoticia.css"

import { Card } from "react-bootstrap"
import CardNoticias from "../CardNoticias"

const PrincipalNoticia = (props) => {
    return (     
            <Card className="bg-dark text-white">
                <Card.Img src={props.imagem} alt="Card image" />
                <Card.ImgOverlay>
                    <a href={props.link_botao}>
                        <Card.Title>{props.titulo}</Card.Title>
                    </a>
                    <Card.Text>
                    </Card.Text>
                    <Card.Text>{props.rodape}</Card.Text>
                </Card.ImgOverlay>
            </Card>
                        
            /*<div className='row noticias'>
                            <div className='row noticia'>
                                <div className='col-4'>
                                    <img className='imagem-noticia' src={props.imagem}></img>
                                </div>
                                <div className='col-4 corpo-noticia'>
                                    <div className='titulo-noticia'>
                                        {props.titulo}
                                    </div>
                                    <div className='texto-noticia'>
                                        {props.texto}
                                        <Button variant="primary" href={props.link_botao}> {props.titulo_botao}</Button>
                                    </div>
                                    <div className='rodape-noticia'>
                                        {props.rodape}
                                    </div>    
                                </div>
                            </div>
                </div>*/
    )
}

export default PrincipalNoticia